import { RightArrowIcon } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import QuestionDescriptionDrawer from "@/app/shared-components/question-description/drawer/drawer";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";

import { useCoverTypeContext } from "../../../provider/cover-type.provider";

export default function Body() {
  const { selectedAnswer, groupedMagnoliaData, setIsDrawerOpen, isDrawerOpen } =
    useCoverTypeContext();
  const { body, isLoadMoreButton, loadMoreButtonText, drawerData } =
    groupedMagnoliaData[selectedAnswer].descriptionSection;

  const { current } = useWizard();
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;

  return (
    <>
      <QuestionDescriptionDrawer
        drawerData={drawerData}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />
      <div
        className={`w-full md:p-0 rounded-radius-lg md:border-none ${
          selectedAnswer === 0
            ? ""
            : "border-border-transparent border bg-surface-accent-transparent p-spacing-m  md:bg-transparent "
        }
       `}
      >
        <div
          className={`leading-[24px] md:leading-[27px] ${
            selectedAnswer === 0 || showNewButtonsLayout
              ? "text-center"
              : "text-left"
          }
          text-2xs md:text-xs md:mb-spacing-m  text-surface-neutral-option-2`}
        >
          <RichText richText={body} />
        </div>
      </div>
      {isLoadMoreButton && (
        <div className={`load-more-wrapper text-center`}>
          <ButtonWrapper
            label={loadMoreButtonText}
            hierarchy="tertiary"
            semanticColor="Dark Background"
            id="load-more-button"
            className={`text-center font-semibold text-xs !leading-custom-size-xxl ${
              showNewButtonsLayout ? "!px-0" : ""
            }`}
            isRightIcon
            rightIcon={<RightArrowIcon stroke="white" />}
            onClick={() => setIsDrawerOpen(true)}
          />
        </div>
      )}
    </>
  );
}
